import { c as _c } from "react/compiler-runtime";
import { usePaxLabel } from '@7f-ui/components/booking-box/booking-box';
import { CardSliderNavButtons } from '@7f-ui/components/card-slider/card-slider';
import { Modal } from '@7f-ui/components/modal/modal';
import { useCanScroll } from '@7f-ui/hooks/use-can-scroll';
import { useDateLabel } from '@7f-ui/hooks/use-date-label';
import { useMediaState } from '@7f-ui/hooks/use-media-state';
import type { AccommodationRate } from '@data-access/graphql/schema.types';
import type { AvailableRoom } from '@feat/feat-accommodation/availability';
import { RatesList } from '@feat/feat-accommodation/booking';
import { useSelectedRoomRate } from '@feat/feat-room-picker/store';
import { useUrlState } from '@feat/feat-url-state/use-url-state';
import { useRef } from 'react';
import { AppAccommodationRoomRatesModalFooter } from './app-accommodation-room-rates-modal-footer';
type AppAccommodationRoomRatesModalContentProps = {
  room: AvailableRoom;
  onSelect: (rate?: AccommodationRate) => Promise<void>;
};
export function AppAccommodationRoomRatesModalContent(t0) {
  const $ = _c(27);
  const {
    room,
    onSelect
  } = t0;
  const isMobile = useMediaState("mobile");
  const {
    rate
  } = useSelectedRoomRate();
  const {
    urlState
  } = useUrlState();
  const t1 = urlState.children?.length;
  const t2 = urlState.allocation?.length;
  let t3;
  if ($[0] !== t1 || $[1] !== t2 || $[2] !== urlState.adults) {
    t3 = {
      adults: urlState.adults,
      children: t1,
      rooms: t2,
      showRooms: false
    };
    $[0] = t1;
    $[1] = t2;
    $[2] = urlState.adults;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const paxLabel = usePaxLabel(t3);
  let t4;
  if ($[4] !== urlState.from || $[5] !== urlState.to) {
    t4 = {
      fromDate: urlState.from,
      toDate: urlState.to
    };
    $[4] = urlState.from;
    $[5] = urlState.to;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const dateLabel = useDateLabel(t4);
  const sliderListRef = useRef(null);
  const {
    canScrollLeft,
    canScrollRight
  } = useCanScroll(sliderListRef);
  const showNavButtons = (canScrollLeft || canScrollRight) && !isMobile;
  let t5;
  if ($[7] !== dateLabel || $[8] !== onSelect || $[9] !== paxLabel || $[10] !== rate) {
    t5 = () => rate && <AppAccommodationRoomRatesModalFooter price={rate.pricing.price} currency={rate.pricing.currency} paxLabel={paxLabel} dateLabel={dateLabel} onClick={async () => await onSelect(rate)} />;
    $[7] = dateLabel;
    $[8] = onSelect;
    $[9] = paxLabel;
    $[10] = rate;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== room || $[13] !== showNavButtons) {
    t6 = showNavButtons && <CardSliderNavButtons sliderListRef={sliderListRef} amountOfItems={room.rates.length} ariaLabelPrevious="vorherige Option anzeigen" ariaLabelNext={"n\xE4chste Option anzeigen"} />;
    $[12] = room;
    $[13] = showNavButtons;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t6) {
    t7 = <div className="hidden items-center justify-end sm:flex">{t6}</div>;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== canScrollLeft || $[18] !== canScrollRight || $[19] !== room) {
    t8 = <RatesList room={room} sliderListRef={sliderListRef} canScrollRight={canScrollRight} canScrollLeft={canScrollLeft} isCheapestRoom={true} />;
    $[17] = canScrollLeft;
    $[18] = canScrollRight;
    $[19] = room;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== t7 || $[22] !== t8) {
    t9 = <div className="full-bleed flex flex-col gap-2">{t7}{t8}</div>;
    $[21] = t7;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== t5 || $[25] !== t9) {
    t10 = <Modal.Content renderFooter={t5} className="px-0">{t9}</Modal.Content>;
    $[24] = t5;
    $[25] = t9;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  return t10;
}